import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LEGITIMATION_STATUS } from 'src/app/model/constants/legitimation-status';
import { ITeacherLegitimation } from 'src/app/model/service/iteacher-legitimation';

@Injectable({
  providedIn: 'root',
})
export class LegitimationService {

  constructor() { }

  public getLegitimation(_ssn: string): Observable<ITeacherLegitimation> {
    return of({ status: LEGITIMATION_STATUS.NONE });
  }
}
